export default "__VITE_ASSET__DcDdePtn__"